import MobileDesignConfig from './MobileDesignConfig.view';

export default MobileDesignConfig;
